module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('server-side-data-table', {
    attrs: {
      "url": this.url,
      "columns": this.columns,
      "extras-column-name": _vm.trans('columns.actions'),
      "storage-key": "pages-index"
    },
    scopedSlots: _vm._u([{
      key: "extras",
      fn: function(ref) {
        var row = ref.row;

        return [(!_vm.disableActions) ? _c('div', {
          staticClass: "btn-group flex-wrap",
          attrs: {
            "id": "project-buttons",
            "data-toggle": "buttons",
            "role": "group"
          }
        }, [_c('a', {
          staticClass: "btn btn-warning btn-sm",
          attrs: {
            "href": '/manage/project/settings/' + row.data.id
          }
        }, [_c('i', {
          staticClass: "fa fa-cogs"
        }), _vm._v(" " + _vm._s(_vm.trans('projects.settings')) + "\n        ")]), _vm._v(" "), _c('a', {
          staticClass: "btn btn-warning btn-sm",
          attrs: {
            "href": '/manage/project/details/' + row.data.id
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" " + _vm._s(_vm.trans('projects.edit')) + "\n        ")]), _vm._v(" "), _c('a', {
          staticClass: "btn btn-secondary btn-sm",
          attrs: {
            "href": '/manage/project/sound/' + row.data.id
          }
        }, [_c('i', {
          staticClass: "fa fa-volume-up"
        }), _vm._v(" " + _vm._s(_vm.trans('projects.sound')) + "\n        ")]), _vm._v(" "), (_vm.canEditCertificate) ? _c('a', {
          staticClass: "btn btn-secondary btn-sm",
          attrs: {
            "href": _vm.route('projects.certificate.edit')
          }
        }, [_c('i', {
          staticClass: "fa fa-file-certificate"
        }), _vm._v(" " + _vm._s(_vm.trans('projects.certificate')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "btn btn-secondary btn-sm",
          attrs: {
            "href": _vm.route('training.player', row.data.id),
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        }), _vm._v(" " + _vm._s(_vm.trans('projects.preview')) + "\n        ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-secondary btn-sm copy",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.copyProject(row.data.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-copy"
        }), _vm._v(" " + _vm._s(_vm.trans('projects.copy')) + "\n        ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.deleteProject(row.data.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        }), _vm._v(" " + _vm._s(_vm.trans('projects.delete')) + "\n        ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-success btn-sm publish",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.publishProject(row.data.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        }), _vm._v(" " + _vm._s(_vm.trans('projects.publish')) + "\n        ")])]) : _c('div', [_vm._v("\n        In dieser Ansicht sind die Schulungen nicht bearbeitbar\n    ")])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e72752e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Projects.vue
// module id = 114
// module chunks = 0